<template>
  <div class="input-group">
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-text-field v-model="node.name" label="Name" hide-details>
        </v-text-field>
      </v-col>
    </v-row>
    <div class="input-title">Transfer to</div>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" class="p-t-0 p-b-0 p-l-25">
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12" class="d-flex p-t-0 p-b-0">
            <v-radio-group v-model="property.type" hide-details>
              <v-radio
                label="Flow"
                value="flow_ui_id"
                class="margin-radio"
              ></v-radio>
            </v-radio-group>
            <v-select
              class="m-l-20"
              v-model="property.flow_ui_id"
              :items="flows"
              item-text="name"
              item-value="_id"
              :disabled="property.type !== 'flow_ui_id'"
              dense
              hide-details
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12" class="d-flex p-t-0 p-b-0">
            <v-radio-group v-model="property.type" hide-details>
              <v-radio
                label="Live agent"
                value="live_agent"
                class="margin-radio"
              ></v-radio>
            </v-radio-group>
            <v-select
              class="m-l-20"
              v-model="property.queue_id"
              :items="queues"
              item-text="name"
              item-value="_id"
              :disabled="property.type !== 'live_agent'"
              dense
              hide-details
            ></v-select>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <hr class="note-divider" />
    <note-component :node="node" />
  </div>
</template>

<script>
import _ from 'lodash'
import apiFlow from '@/apis/flow'
import apiQueue from '@/apis/queue'

import NoteComponent from '../../../components/note'

export default {
  props: {
    node: Object,
    flowId: String
  },
  components: {
    NoteComponent
  },
  data() {
    return {
      property: {},
      queues: [],
      flows: []
    }
  },
  watch: {
    'property.flow_ui_id': {
      handler(value) {
        if (value) {
          const flow = _.find(this.flows, { _id: value })
          if (flow) this.property.flow_ui_name = flow.name
        }
      }
    },
    'property.queue_id': {
      handler(value) {
        if (value) {
          const queue = _.find(this.queues, { _id: value })
          if (queue) this.property.queue_name = queue.name
        }
      }
    }
  },
  created() {
    this.property = this.node.property
    this.initial()
  },
  methods: {
    async initial() {
      await this.getFlow('chat')
      await this.getQueueChat()
    },
    // async initial() {
    //   await this.getFlow('chat')
    //   if (this.flows.length > 0 && !this.property.flow_ui_id) {
    //     this.property.flow_ui_id = this.flows[0]._id
    //   }

    //   await this.getQueueChat()
    //   if (this.queues.length > 0 && !this.property.queue_id) {
    //     this.property.queue_id = this.queues[0]._id
    //   }
    // },
    async getQueueChat() {
      try {
        const getQueue = await apiQueue.getQueueChat()
        const { data } = getQueue
        this.queues = data
      } catch {}
    },
    async getFlow(platform) {
      try {
        const flows = await apiFlow.listFlowUiByPlatform(platform)
        this.flows = _.filter(flows.data, o => {
          return o._id !== this.flowId
        })
      } catch {}
    }
  }
}
</script>

<style scoped lang="scss">
.no-margin-top {
  margin-top: 0px !important;
}
.body-dialog {
  margin: 10px !important;
}
.margin-radio {
  margin-top: 10px;
  width: 100px;
}
</style>
